import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions, ViewStyle} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return {
    flatListStyle: {
      marginTop: 16,
    },
  };
};
